var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBergabung(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.82524 15.9776C3.27018 14.4162 0 12.3269 0 7.36197V2.51449C0 2.29376 0.183515 2.1144 0.409969 2.1144C3.31394 2.1136 6.10595 1.19412 7.76479 0.0491095C7.82089 0.0103893 7.89252 0 7.96144 0H8.03829C8.10694 0 8.17834 0.0106878 8.23493 0.0491095C9.92443 1.1961 12.6855 2.1136 15.5898 2.1144C15.8162 2.1144 16 2.29376 16 2.51449V7.36197C16 12.3269 12.7293 14.4165 8.17422 15.9776C8.13046 15.9925 8.08451 16 8.03829 16H7.96144C7.91494 16 7.869 15.9925 7.82524 15.9776ZM7.93141 8.52708C5.96954 8.52708 4.37598 9.2959 4.37598 11.1961H11.4868C11.4868 9.2959 9.89328 8.52708 7.93141 8.52708ZM8 4.12565C8.91977 4.12565 9.66667 4.87239 9.66667 5.79232C9.66667 6.71225 8.91977 7.45898 8 7.45898C7.08024 7.45898 6.33333 6.71225 6.33333 5.79232C6.33333 4.87239 7.08024 4.12565 8 4.12565Z",
    fill: "#666687"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBergabung);
export default __webpack_public_path__ + "static/media/ic-bergabung.e579cea95b389c0e0f05140e7b08b8ba.svg";
export { ForwardRef as ReactComponent };